import classNames from 'classnames';

import { useTimeZonedFunctions } from '/src/hooks';

export function DateDisplay({ className, date, full, time }) {
  const { formatDay, formatDayFull, formatDateTime, formatDateTimeFull } = useTimeZonedFunctions();

  if (!date) return null;

  let displayDate;
  if (time) {
    displayDate = full ? formatDateTimeFull(date) : formatDateTime(date);
  } else {
    displayDate = full ? formatDayFull(date) : formatDay(date);
  }

  return <span className={classNames(className)}>{displayDate}</span>;
}
